import request from '@/utils/request'

// 创建管理员
export const addMerchantManager = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/manager',
    method: 'post',
    data
})

// 删除管理员
export const delMerchantManager = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/manager/' + data.id,
    method: 'delete',
    data
})

// 编辑管理员
export const setMerchantManager = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/manager/' + data.id,
    method: 'patch',
    data
})

// 获取管理员
export const getMerchantManagerList = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/manager',
    method: 'get',
    params
})

// 获取产品详情
export const getMerchantManagerInfo = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/manager/' + params.id,
    method: 'get'
})

// 获取管理员菜单权限列表
export const getMerchantManagerAuthList = (params: any) => request({
    url: '/manage/merchant/manager/' + params + '/authorize/menu',
    method: 'get'
})

// 设置管理员菜单权限
export const setMerchantManagerAuth = (data: any) => request({
    url: '/manage/merchant/manager/' + data.manager_id + '/authorize/menu',
    method: 'post',
    data
})